import { error } from 'highcharts'
import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'inspection_format',
	'el formato de inspeccion',
	'los formatos de inspeccion'
)

const getFormatByID = (format_id) => {
	return async (dispatch, getState) => {
		console.log('hará la peticion')

		const state = getState()
		let res = await callApi(`/inspection_format/utils/get_format_by_id`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},

			params: format_id,
		})
		return res.body
	}
}

const saveFormat = (data) => {
	return async (dispatch, getState) => {
		const state = getState()
		let res;
		try {
			res = await callApi(`/inspection_format/save_format`, {
			method: 'POST',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				inspection_format: JSON.stringify({
					data: data,
				}),
				files: [...data.files, ...data.documents],
			},
			successMessage: `Se agregó el formato de inspección correctamente.`,
		})
	}	catch (err) {
		console.log("err", err)
		showErrorMessage(
			'Hubo un error al guardar el formato de inspección. Por favor, inténtalo de nuevo.',error
		)
		return
	}
		
		const stored_item = res.body?.inspection_format || res.body;
		if (data.id) {
			dispatch({
				type: 'UPDATE_INSPECTION_FORMAT',
				response: stored_item,
			})
		} else {
			dispatch({
				type: 'ADD_INSPECTION_FORMAT',
				response: stored_item,
			})
		}

		showSuccessMessage(
			'Los formatos de inspección se registrarón correctamente'
		)
		return res.body
	}
}

const loadFormatsDriver = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/employee/utils/get_employee_units_inspection_formats`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.driver?.token || '',
				},
			}
		)

		dispatch({
			type: `GET_DRIVER_UNITS_FORMATS`,
			response: res.body,
		})

		return res.body
	}
}

const getPushNotificationUsers = (inspectionFormatId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/inspection_format/get_push_notification_users/${inspectionFormatId}`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)

		return res.body
	}
}

const save_user_inspection = (data) => {
	return async (dispatch, getState) => {
		const state = getState()
		let res = await callApi(`/inspection_format/save_user_inspection`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				data,
			}),
			successMessage: `Operación realizada correctamente.`,
		})
		return res.body
	}
}

const get_users_inspection = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/inspection_format/utils/get_users_inspection`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: params,
		})

		return res.body
	}
}

export default {
	...actions,
	saveFormat,
	loadFormatsDriver,
	getFormatByID,
	getPushNotificationUsers,
	save_user_inspection,
	get_users_inspection,
}
